import React from 'react'
import Box from '@material-ui/core/Box'
import Typography from '@material-ui/core/Typography'
import { makeStyles } from '@material-ui/core/styles'
import { requiredLabel } from './field-styles'

const useStyles = makeStyles(theme => ({
  root: {
    display: 'flex',
    flexDirection: 'column',
    gap: theme.spacing(0.5),
  },
  title: {
    fontSize: '1rem',
    fontWeight: 400,
    color: theme.palette.text.primary,
    lineHeight: 1.3,
    margin: 0,
  },
  description: {
    fontSize: '0.8125rem',
    fontWeight: 400,
    color: theme.palette.text.secondary,
    lineHeight: 1.5,
    margin: 0,
  },
}))

const FormSubheader = ({ title, description, required = false }) => {
  const classes = useStyles()

  return (
    <Box className={classes.root}>
      <Typography component="h3" className={classes.title}>
        {required ? requiredLabel(title) : title}
      </Typography>
      {description ? (
        <Typography component="p" className={classes.description}>
          {description}
        </Typography>
      ) : null}
    </Box>
  )
}

export default FormSubheader
